var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.751 15.8598H8.69129L7.14674 9.79394C7.07343 9.51491 6.91776 9.26823 6.68879 9.15197C6.11737 8.85979 5.4877 8.62727 4.80078 8.50999V8.27646H8.11886C8.57681 8.27646 8.92026 8.62727 8.97751 9.03469L9.77891 13.4102L11.8376 8.27646H13.8401L10.751 15.8598ZM14.985 15.8598H13.0398L14.6415 8.27646H16.5868L14.985 15.8598ZM19.1035 10.3773C19.1607 9.96884 19.5042 9.7353 19.9049 9.7353C20.5346 9.67667 21.2205 9.79394 21.7929 10.0851L22.1364 8.45237C21.5639 8.21884 20.9343 8.10156 20.3628 8.10156C18.4748 8.10156 17.101 9.15197 17.101 10.6098C17.101 11.7188 18.0741 12.3012 18.761 12.652C19.5042 13.0018 19.7904 13.2353 19.7332 13.5851C19.7332 14.1098 19.1607 14.3433 18.5893 14.3433C17.9024 14.3433 17.2155 14.1684 16.5868 13.8763L16.2433 15.51C16.9303 15.8012 17.6734 15.9185 18.3603 15.9185C20.4773 15.9761 21.7929 14.9267 21.7929 13.3516C21.7929 11.368 19.1035 11.2518 19.1035 10.3773ZM28.6008 15.8598L27.0562 8.27646H25.3972C25.0537 8.27646 24.7103 8.50999 24.5958 8.85979L21.7356 15.8598H23.7381L24.1378 14.7518H26.5983L26.8273 15.8598H28.6008ZM25.6827 10.3203L26.2541 13.1784H24.6523L25.6827 10.3203Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.6c5fb7b20b2800f49109850d75c3dc93.svg";
export { ForwardRef as ReactComponent };